import { FC, SVGProps } from 'react';

const MenuIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.66602 25.9802C2.66602 25.3256 3.2087 24.795 3.87814 24.795H28.1206C28.79 24.795 29.3327 25.3256 29.3327 25.9802C29.3327 26.6347 28.79 27.1654 28.1206 27.1654H3.87814C3.2087 27.1654 2.66602 26.6347 2.66602 25.9802ZM2.66602 16.4987C2.66602 15.8441 3.2087 15.3135 3.87814 15.3135H28.1206C28.79 15.3135 29.3327 15.8441 29.3327 16.4987C29.3327 17.1533 28.79 17.6839 28.1206 17.6839H3.87814C3.2087 17.6839 2.66602 17.1533 2.66602 16.4987ZM2.66602 7.01722C2.66602 6.36266 3.2087 5.83203 3.87814 5.83203H28.1206C28.79 5.83203 29.3327 6.36266 29.3327 7.01722C29.3327 7.67178 28.79 8.2024 28.1206 8.2024H3.87814C3.2087 8.2024 2.66602 7.67178 2.66602 7.01722Z"
      fill="currentColor"
    />
  </svg>
);

export default MenuIcon;
